// Campanita de intentos de entrega (TODOS los usuarios: cada sucursal recibe los de
// sus choferes; matriz recibe todos).
//   total:        intentos de entrega de HOY visibles para el usuario segun el API (carga
//                 inicial + resincronizacion al llegar un push con el modulo abierto) + pushes recibidos
//   recientes:    ultimos avisos recibidos por push en ESTA sesion de pestana (mas nuevo primero);
//                 tipo 'intento' (id 'i{intento_id}') o 'solicitud' (legado, id numerico)
//   noVistas:     avisos recibidos desde la ultima vez que se abrio la campanita / el modulo
//   ultimoAviso:  el push mas reciente (dispara el snackbar y el auto-refresh del modulo); null al cerrarlo
//   tokenWeb:     token FCM registrado en el API ('' si no hay), tokenEstado: 'pendiente'|'registrado'|'no_disponible'
const MAX_RECIENTES = 20;

const initState = {
    total: null,
    recientes: [],
    noVistas: 0,
    ultimoAviso: null,
    tokenWeb: "",
    tokenEstado: "pendiente",
    notif_Error_Message: null,
};

const notificacionesReducer = (state = initState, action) => {
    switch (action.type) {
        case "NOTIF_TOTAL_SUCCESS":
            return {
                ...state,
                total: parseInt(action.payload.total, 10) || 0,
                notif_Error_Message: null,
            };
        case "NOTIF_NUEVO_AVISO": {
            const a = action.payload.aviso;
            // un reenvio del mismo aviso (mismo id) no duplica ni vuelve a contar
            const tieneId = a.id != null && a.id !== "" && a.id !== 0;
            const yaEstaba = tieneId && state.recientes.some((r) => r.id === a.id);
            if (yaEstaba) {
                return { ...state, ultimoAviso: a };
            }
            return {
                ...state,
                // el total cuenta intentos de entrega; un aviso legado de solicitud no suma
                total: a.tipo === "intento" ? (state.total || 0) + 1 : state.total,
                recientes: [a].concat(state.recientes).slice(0, MAX_RECIENTES),
                noVistas: state.noVistas + 1,
                ultimoAviso: a,
            };
        }
        case "NOTIF_MARCAR_VISTAS":
            return { ...state, noVistas: 0 };
        case "NOTIF_CERRAR_AVISO":
            return { ...state, ultimoAviso: null };
        case "NOTIF_TOKEN_REGISTRADO":
            return { ...state, tokenWeb: action.payload.token, tokenEstado: "registrado" };
        case "NOTIF_TOKEN_NO_DISPONIBLE":
            return { ...state, tokenWeb: "", tokenEstado: "no_disponible" };
        case "NOTIF_TOKEN_ELIMINADO":
            return { ...state, tokenWeb: "", tokenEstado: "pendiente" };
        case "NOTIF_ERROR":
            return { ...state, notif_Error_Message: action.payload.error };
        case "NOTIF_CLOSE_MESSAGES":
            return { ...state, notif_Error_Message: null };
        default:
            return state;
    }
};

export default notificacionesReducer;
